//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    min-height: var(--min-height-without-header);
    padding: 30px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    
`;
export const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    & > img {
        width: 230px;
        height: 170px;
    }
    & > p {
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        color: var(--dark-4);
    }
`;